import { render, staticRenderFns } from "./certificationList.vue?vue&type=template&id=f2ec6aa4&scoped=true"
import script from "./certificationList.vue?vue&type=script&lang=js"
export * from "./certificationList.vue?vue&type=script&lang=js"
import style0 from "./certificationList.vue?vue&type=style&index=0&id=f2ec6aa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ec6aa4",
  null
  
)

export default component.exports